var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuctionWithBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5357",
    "data-name": "Group 5357",
    transform: "translate(0.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(-0.04)",
    fill: "#fff8e4",
    stroke: "#ffc629",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535",
    transform: "translate(32.854 36.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478",
    transform: "translate(2.983 67.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(1.492 1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M44.193,419.169a2.984,2.984,0,0,0-2.983,2.984v2.983H71.045v-2.983a2.984,2.984,0,0,0-2.983-2.984Z",
    transform: "translate(-41.21 -419.169)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(23.869 1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M168.417,419.169h-4.475a2.984,2.984,0,0,1,2.984,2.984v2.983H171.4v-2.983A2.984,2.984,0,0,0,168.417,419.169Z",
    transform: "translate(-163.942 -419.169)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(1.492 1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M48.669,419.169H44.193a2.984,2.984,0,0,0-2.983,2.984v2.983h4.475v-2.983A2.984,2.984,0,0,1,48.669,419.169Z",
    transform: "translate(-41.21 -419.169)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M64.352,419.937H34.517a1.491,1.491,0,0,1-1.492-1.492v-2.983a4.48,4.48,0,0,1,4.475-4.475H61.369a4.48,4.48,0,0,1,4.475,4.475v2.983A1.491,1.491,0,0,1,64.352,419.937Zm-28.344-2.983H62.86v-1.492a1.493,1.493,0,0,0-1.492-1.492H37.5a1.493,1.493,0,0,0-1.492,1.492Z",
    transform: "translate(-33.025 -410.987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(6.298 50.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(20.043 8.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M162.627,374.587a1.492,1.492,0,0,1-1.055-2.546l2.109-2.11a1.492,1.492,0,1,1,2.109,2.109l-2.109,2.11A1.487,1.487,0,0,1,162.627,374.587Z",
    transform: "translate(-161.135 -369.493)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(16.171 4.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M141.389,351.32a1.493,1.493,0,0,1-1.378-2.064l1.713-4.134a1.492,1.492,0,1,1,2.756,1.142l-1.713,4.134A1.492,1.492,0,0,1,141.389,351.32Z",
    transform: "translate(-139.897 -344.201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(11.604 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M116.339,331.426a1.491,1.491,0,0,1-1.492-1.492v-7.459a1.492,1.492,0,1,1,2.983,0v7.459A1.491,1.491,0,0,1,116.339,331.426Z",
    transform: "translate(-114.847 -320.983)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(5.896 5.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M86.173,357.5a1.492,1.492,0,0,1-1.378-.922l-1.141-2.756a1.491,1.491,0,1,1,2.756-1.141l1.141,2.757a1.494,1.494,0,0,1-1.378,2.063Z",
    transform: "translate(-83.541 -351.762)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(3.612 0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M73.074,325.887a1.492,1.492,0,0,1-1.378-.921l-.571-1.378a1.492,1.492,0,1,1,2.756-1.142l.571,1.378a1.493,1.493,0,0,1-1.378,2.063Z",
    transform: "translate(-71.012 -321.525)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484",
    transform: "translate(0 7.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M55.861,369.856a1.487,1.487,0,0,1-1.055-.437l-3.166-3.165a1.492,1.492,0,1,1,2.109-2.109l3.166,3.165a1.492,1.492,0,0,1-1.055,2.546Z",
    transform: "translate(-51.203 -363.708)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(16.456 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490",
    transform: "translate(28.297 28.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    transform: "translate(1.492 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 5.967,
    height: 14.918,
    transform: "translate(0 4.219) rotate(-45)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    transform: "translate(3.602 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 2.984,
    height: 14.918,
    transform: "translate(0 2.11) rotate(-45)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488",
    transform: "translate(0 4.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M271,230.116a1.487,1.487,0,0,1-1.055-.437l-7.385-7.384a1.492,1.492,0,1,1,2.109-2.109l7.385,7.384A1.492,1.492,0,0,1,271,230.116Z",
    transform: "translate(-262.126 -219.749)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(4.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M297.313,210.137a1.486,1.486,0,0,1-1.055-.437l-10.547-10.549a1.492,1.492,0,1,1,2.109-2.11l10.547,10.549a1.492,1.492,0,0,1-1.055,2.547Z",
    transform: "translate(-285.274 -196.605)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(39.028 38.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    transform: "translate(1.49 1.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M354.295,282.444l-17.932-17.932a2.984,2.984,0,0,0-4.22,0l-2.11,2.11a2.983,2.983,0,0,0,0,4.219l17.932,17.932a2.984,2.984,0,0,0,4.219,0l2.11-2.11A2.984,2.984,0,0,0,354.295,282.444Z",
    transform: "translate(-329.16 -263.638)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(2.364 1.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M358.215,282.444l-17.932-17.932a2.984,2.984,0,0,0-4.22,0l-2.109,2.11a2.983,2.983,0,0,1,4.219,0L356.1,284.554a2.984,2.984,0,0,1,0,4.22l2.11-2.11A2.984,2.984,0,0,0,358.215,282.444Z",
    transform: "translate(-333.953 -263.638)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(1.49 2.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M350.075,290.582,332.143,272.65a2.983,2.983,0,0,1,0-4.219l-2.11,2.109a2.983,2.983,0,0,0,0,4.219l17.932,17.932a2.983,2.983,0,0,0,4.219,0l2.11-2.11A2.984,2.984,0,0,1,350.075,290.582Z",
    transform: "translate(-329.16 -268.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(13.53 7.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M398.8,300.056a1.487,1.487,0,0,1-1.055-.437l-2.11-2.11a1.492,1.492,0,1,1,2.11-2.109l2.109,2.109a1.492,1.492,0,0,1-1.055,2.547Z",
    transform: "translate(-395.198 -294.963)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M343.392,284.454a4.465,4.465,0,0,1-3.164-1.307L322.3,265.214a4.481,4.481,0,0,1,0-6.329l2.11-2.109a4.481,4.481,0,0,1,6.33,0l3.164,3.165a1.492,1.492,0,0,1-2.109,2.11l-3.164-3.165a1.5,1.5,0,0,0-2.111,0l-2.109,2.11a1.494,1.494,0,0,0,0,2.11l17.932,17.933a1.494,1.494,0,0,0,2.111,0l2.11-2.11a1.49,1.49,0,0,0,0-2.109l-6.33-6.33a1.492,1.492,0,1,1,2.109-2.109l6.33,6.329a4.475,4.475,0,0,1,0,6.329l-2.109,2.109A4.467,4.467,0,0,1,343.392,284.454Z",
    transform: "translate(-320.987 -255.466)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    transform: "translate(7.201 19.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(1.491 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    "data-name": "Rectangle 1742",
    width: 5.967,
    height: 19.393,
    transform: "translate(0 4.219) rotate(-45.001)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(13.095 13.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    "data-name": "Rectangle 1743",
    width: 5.967,
    height: 2.984,
    transform: "translate(0 4.219) rotate(-45)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(1.491 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 5.967,
    height: 2.984,
    transform: "translate(0 4.219) rotate(-45.001)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(13.713 13.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M223.122,232.737a1.492,1.492,0,0,1-1.055-2.547l4.219-4.22a1.492,1.492,0,1,1,2.109,2.109l-4.219,4.22A1.487,1.487,0,0,1,223.122,232.737Z",
    transform: "translate(-221.63 -225.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M147.909,157.523a1.492,1.492,0,0,1-1.055-2.547l4.219-4.219a1.492,1.492,0,0,1,2.109,2.109l-4.219,4.22A1.488,1.488,0,0,1,147.909,157.523Z",
    transform: "translate(-146.417 -150.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508",
    transform: "translate(19.859 7.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(1.492 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    "data-name": "Rectangle 1745",
    width: 5.967,
    height: 19.393,
    transform: "translate(0 4.219) rotate(-44.999)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504",
    transform: "translate(13.095 13.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 5.967,
    height: 2.984,
    transform: "translate(0 4.22) rotate(-45.001)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(1.491 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 5.967,
    height: 2.984,
    transform: "translate(0 4.219) rotate(-44.999)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(13.713 13.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M292.551,163.309a1.492,1.492,0,0,1-1.055-2.547l4.219-4.219a1.492,1.492,0,1,1,2.109,2.11l-4.219,4.219A1.487,1.487,0,0,1,292.551,163.309Z",
    transform: "translate(-291.059 -156.105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M217.337,88.1a1.492,1.492,0,0,1-1.055-2.546l4.219-4.22a1.492,1.492,0,1,1,2.11,2.109l-4.219,4.22A1.488,1.488,0,0,1,217.337,88.1Z",
    transform: "translate(-215.845 -80.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    transform: "translate(10.365 10.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(1.492 1.491)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 11.934,
    height: 22.377,
    transform: "translate(0 8.439) rotate(-45)",
    fill: "#f4d01e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    transform: "translate(14.15 14.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 11.934,
    height: 4.475,
    transform: "translate(0 8.439) rotate(-45)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(1.492 1.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 11.934,
    height: 4.475,
    transform: "translate(0 8.439) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M181.086,125.5a1.487,1.487,0,0,1-1.055-.437l-15.823-15.822a1.492,1.492,0,0,1,0-2.11l8.439-8.439a1.491,1.491,0,0,1,2.11,0L190.58,114.51a1.491,1.491,0,0,1,0,2.109l-8.439,8.439A1.487,1.487,0,0,1,181.086,125.5Zm-13.713-17.314,13.713,13.713,6.33-6.329L173.7,101.852Z",
    transform: "translate(-163.772 -98.251)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518",
    transform: "translate(0 23.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514",
    transform: "translate(0.253 0.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    d: "M4.475,0h0A4.475,4.475,0,0,1,8.951,4.475v16.41A4.475,4.475,0,0,1,4.475,25.36h0A4.475,4.475,0,0,1,0,20.885V4.475A4.475,4.475,0,0,1,4.475,0Z",
    transform: "translate(0 6.329) rotate(-45)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(12.912 12.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M187.233,242.666l-3.165-3.165a2.983,2.983,0,0,1,0,4.219l-2.11,2.11a2.983,2.983,0,0,1-4.219,0L180.9,249a2.983,2.983,0,0,0,4.219,0l2.11-2.11A2.983,2.983,0,0,0,187.233,242.666Z",
    transform: "translate(-177.74 -239.502)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516",
    transform: "translate(1.489 1.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M119.129,183l2.11-2.11a2.984,2.984,0,0,1,4.219,0l-3.164-3.165a2.984,2.984,0,0,0-4.22,0l-2.11,2.11a2.984,2.984,0,0,0,0,4.219l3.165,3.164A2.983,2.983,0,0,1,119.129,183Z",
    transform: "translate(-115.09 -176.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M125.106,193.451a4.464,4.464,0,0,1-3.164-1.307L108.229,178.43a4.483,4.483,0,0,1,0-6.328l2.111-2.11a4.48,4.48,0,0,1,6.33,0l3.164,3.164a1.492,1.492,0,1,1-2.109,2.11l-3.164-3.164a1.5,1.5,0,0,0-2.111,0l-2.109,2.109a1.494,1.494,0,0,0,0,2.111l13.711,13.712a1.494,1.494,0,0,0,2.111,0l2.11-2.109a1.491,1.491,0,0,0,0-2.109l-7.385-7.385A1.492,1.492,0,1,1,123,176.32l7.385,7.384a4.475,4.475,0,0,1,0,6.329l-2.109,2.109A4.466,4.466,0,0,1,125.106,193.451Z",
    transform: "translate(-106.921 -168.682)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(23.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(1.492 1.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M263.291,64.155,249.578,50.442a2.984,2.984,0,0,0-4.219,0l-2.11,2.11a2.984,2.984,0,0,0,0,4.219l13.713,13.713a2.983,2.983,0,0,0,4.219,0l2.11-2.11A2.983,2.983,0,0,0,263.291,64.155Z",
    transform: "translate(-242.375 -49.568)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(12.914 12.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M314.518,115.383l-3.164-3.165a2.983,2.983,0,0,1,0,4.219l-2.11,2.11a2.984,2.984,0,0,1-4.22,0l3.165,3.165a2.983,2.983,0,0,0,4.219,0l2.11-2.11A2.983,2.983,0,0,0,314.518,115.383Z",
    transform: "translate(-305.024 -112.218)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(1.492 1.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M246.413,55.716l2.11-2.11a2.983,2.983,0,0,1,4.219,0l-3.164-3.165a2.984,2.984,0,0,0-4.219,0l-2.11,2.11a2.984,2.984,0,0,0,0,4.219l3.165,3.165A2.984,2.984,0,0,1,246.413,55.716Z",
    transform: "translate(-242.375 -49.568)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M252.379,66.351a4.46,4.46,0,0,1-3.164-1.309L235.5,51.329a4.475,4.475,0,0,1,0-6.329l2.11-2.109a4.583,4.583,0,0,1,6.328,0l3.166,3.165A1.492,1.492,0,1,1,245,48.165L241.831,45a1.528,1.528,0,0,0-2.109,0l-2.109,2.109a1.49,1.49,0,0,0,0,2.109l13.713,13.714a1.494,1.494,0,0,0,2.109,0l2.11-2.11a1.5,1.5,0,0,0,0-2.11l-7.383-7.384a1.492,1.492,0,0,1,2.109-2.109l7.383,7.384a4.48,4.48,0,0,1,0,6.329l-2.11,2.109A4.46,4.46,0,0,1,252.379,66.351Z",
    transform: "translate(-234.191 -41.623)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(0 73.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M55.447,446.7H18.153a1.492,1.492,0,1,1,0-2.983H55.447a1.492,1.492,0,1,1,0,2.983Z",
    transform: "translate(-16.661 -443.716)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526",
    transform: "translate(41.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M248.745,446.7h-1.492a1.492,1.492,0,1,1,0-2.983h1.492a1.492,1.492,0,1,1,0,2.983Z",
    transform: "translate(-245.761 -443.716)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionWithBorder);
export default __webpack_public_path__ + "static/media/auctionWithBorder.270e10094b3b9a2f40834bb5ff0058bc.svg";
export { ForwardRef as ReactComponent };